(() => {
  if (typeof window === 'undefined') return;

  const html = document.documentElement;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) {
    html.classList.add('aureum-no-motion');
    return;
  }

  if (!html.classList.contains('aureum-js-ready')) {
    html.classList.add('aureum-js-ready');
  }

  const reveal = (el) => {
    if (!el.classList.contains('is-in-view')) {
      el.classList.add('is-in-view');
    }
  };

  const supportsIO = 'IntersectionObserver' in window;

  const sectionObserver = supportsIO
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              sectionObserver.unobserve(entry.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
      )
    : null;

  const wireUp = (root) => {
    const scope = root instanceof Element ? root : document;
    if (!supportsIO) {
      scope.querySelectorAll('.aureum-enter:not(.is-in-view)').forEach(reveal);
      return;
    }
    scope.querySelectorAll('.aureum-enter:not(.is-in-view)').forEach((el) => sectionObserver.observe(el));
  };

  const start = () => {
    requestAnimationFrame(() => requestAnimationFrame(() => wireUp(document)));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  const handleSectionEvent = (event) => {
    const target = event.target instanceof Element ? event.target : document;
    wireUp(target);
  };

  document.addEventListener('shopify:section:load', handleSectionEvent);
  document.addEventListener('shopify:section:select', handleSectionEvent);

  if ('MutationObserver' in window) {
    const mo = new MutationObserver((mutations) => {
      let needsWireup = false;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.classList?.contains('aureum-enter') || node.querySelector?.('.aureum-enter')) {
            needsWireup = true;
            break;
          }
        }
        if (needsWireup) break;
      }
      if (needsWireup) wireUp(document);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
